import { Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { S1ButtonType, S1UIService } from '@app/s1';
import { ILoginUtenteParams, UtenteService } from '@app/shared/services/utente.service';
import { MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, PopupRequest } from '@azure/msal-browser';

@Component({
  selector: 'ser-azure-login',
  templateUrl: './azure-login.component.html',
  styleUrl: './azure-login.component.scss'
})
export class AzureLoginComponent {

  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, private msalService: MsalService, private router: Router, private utenteService: UtenteService, private ui: S1UIService) {
    
  }

  s1ButtonType = S1ButtonType;

  openAzure() {

    const popRequest: PopupRequest = this.msalGuardConfig.authRequest ? {...this.msalGuardConfig.authRequest} as PopupRequest : null;

    this.msalService.loginPopup(popRequest).subscribe((response: AuthenticationResult) => {
      
      this.msalService.instance.setActiveAccount(response.account);
      localStorage.setItem("azureAccount", JSON.stringify(response.account));
      localStorage.setItem("azureToken", response?.accessToken);

      const azureToken = response?.accessToken;

      if (azureToken) {

        const params: ILoginUtenteParams = {
          token: azureToken
        }

        this.utenteService.login(params).subscribe(logged => { 

          if (logged) {
            this.router.navigate(["/"]);
          }

        });
      }

    }, error => {
      console.log("ERR: ", error);
      this.ui.showHTTPErrorPopup(error);
    });

    // if (this.msalGuardConfig.authRequest){
    //   this.msalService.loginPopup({...this.msalGuardConfig.authRequest} as PopupRequest)
    //     .subscribe((response: AuthenticationResult) => {
    //       console.log("RES: ", response)
    //       this.msalService.instance.setActiveAccount(response.account);
    //     });
    //   } else {
    //     this.msalService.loginPopup(null)
    //       .subscribe((response: AuthenticationResult) => {
    //         this.msalService.instance.setActiveAccount(response.account);
    //   });
    // }
    
  }

}
